import React, { useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import { SuccessInfoBox } from "@app/preBill/components/successInfoBox";
import { AccountInfoBox } from "@app/preBill/components/accountInfoBox";
import { useTokenizedLinkSignUp } from "@app/ups/hooks";
import { useUPSHeapEvent } from "@app/ups/hooks";
import { HEAP_EVENTS } from "@app/provider/types";

import "./upsCreatePaymentConfirmation.scss";

const messages = defineMessages({
  upsDirectPaymentConfirmationTitle: {
    id: "upsDirectPaymentConfirmationTitle",
    defaultMessage: "Thank you for your payment!",
  },
  upsDirectPaymentConfirmationDescription: {
    id: "upsDirectPaymentConfirmationDescription",
    defaultMessage:
      "We’ve received your payment. You’ll receive a confirmation email shortly.",
  },
});

const UPSCreatePaymentConfirmation: React.FC = () => {
  const intl = useIntl();
  const { redirectToTokenizedSignUp, isLoading } = useTokenizedLinkSignUp();
  const { trackUPSHeapEvent } = useUPSHeapEvent();

  useEffect(() => {
    trackUPSHeapEvent({
      eventKey: HEAP_EVENTS.ups_view_billing_payment_confirmation,
    });
  }, []);

  return (
    <div className="ups-direct-payment-confirmation">
      <div className="ups-direct-payment-confirmation__content">
        <SuccessInfoBox
          title={intl.formatMessage(messages.upsDirectPaymentConfirmationTitle)}
          description={intl.formatMessage(
            messages.upsDirectPaymentConfirmationDescription
          )}
        />
        <AccountInfoBox
          createAccountButtonAction={redirectToTokenizedSignUp}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default UPSCreatePaymentConfirmation;
